import { getTranslation } from 'utils/getTranslation';
import * as yup from 'yup';

import { PetMicrochipField } from './fields';

const { chipNo, hasMicrochip } = PetMicrochipField;

type DonorMicrochipSectionSchemaType = {
  microchipNumber?: string;
  hasMicrochip?: boolean;
};

const t = getTranslation('donor.ValidationErrors');

const donorMicrochipSectionSchema: yup.SchemaOf<DonorMicrochipSectionSchemaType> =
  yup.object({
    [chipNo]: yup
      .string()
      .test({
        test: (value) => value?.trim() === value,
        message: t('mustBeTrim'),
      })
      .max(50, t('shorterThan', { max: 50, field: t('chipNo') })),
    [hasMicrochip]: yup.boolean(),
  });

export { donorMicrochipSectionSchema };
export type { DonorMicrochipSectionSchemaType };
